import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'formatDate' })
export class FormatDatePipe implements PipeTransform {
  transform(value: string | Date): string {
    if (!value) return '';

    const date = new Date(value);
    const isoDate = date.toISOString().split('T')[0];
    const [year, month, day] = isoDate.split('-');

    return `${month}/${day}/${year}`;
  }
}
